import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

import { Provider } from 'react-redux'
import { initStore } from 'store'

import AppRoutes from './routes'

import { getAuth, onAuthStateChanged } from 'firebase/auth'

function App() {
  const store = initStore()

  const auth = getAuth()
  onAuthStateChanged(auth, (user) => {
    console.log('auth state change.')
    if (user) {
      user
        .getIdTokenResult()
        .then((idTokenResult) => {
          if (
            idTokenResult.claims.admin ||
            user?.uid == 'NYZ72DtiBbcOEoQQP7uJGiktNev1' ||
            user?.uid == '8OJOKsB1pKcLxpOSMnyTMUydXm72' ||
            user?.uid == 'EczFnHjjOHT2Vqd5K3THNJ6he3q1' ||
            user?.uid == 'jqJ8iu3TH0hmTm4zvrOdmMz6mzE3' ||
            user?.uid == 'X7FHpg5yJvfOSjsFLgalxupxDJb2'
          ) {
            localStorage.setItem('adminAccess', 'true')
          } else {
            localStorage.setItem('adminAccess', 'false')
          }
        })
        .catch((error) => {
          console.log(error)
        })
      // User is signed in, see docs for a list of available properties
      // https://firebase.google.com/docs/reference/js/firebase.User
      const uid = user.uid

      // ...
    } else {
      // User is signed out
      // ...
      localStorage.setItem('adminAccess', 'false')
    }
  })

  return (
    <Provider store={store}>
      <Router>
        <AppRoutes />
      </Router>
    </Provider>
  )
}

export default App
